/**
 * Height of a sandboxed email iframe.
 *
 * An email is as long as it is, so the frame takes its height and the page or
 * popup around it scrolls once, rather than a scroller inside a scroller.
 *
 * @link ./EmailPreviewFrame for the frame this is attached to.
 */

/** Keeps a very short email from collapsing the panel it sits in. */
const MIN_HEIGHT = 320;

/**
 * Set the frame to the height of its email.
 *
 * The email's body is `height: 100%`, so it reports the frame's own height until
 * the frame lets go of it; the frame is collapsed first and measured after. The
 * frame never scrolls, or a scrollbar would take width and change the measurement.
 *
 * @param frame - the loaded iframe; needs `allow-same-origin` to be reachable.
 */
export function fitFrameToEmail(frame: HTMLIFrameElement): void {
  const page = frame.contentDocument?.documentElement;
  if (!page) return;
  page.style.overflow = 'hidden';
  frame.style.height = '0px';
  frame.style.height = `${Math.max(page.scrollHeight, MIN_HEIGHT)}px`;
}
